module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/mindful/mindful-03_layoutphoto_01.png";